import { Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Buffer } from 'buffer';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAppDispatch } from "../../redux/hooks";
import { resetPassword} from "../../redux/UserAPI";
import { ActionButton } from "../ActionButton/ActionButton";


interface Errors {
  password: boolean;
  passwordConfirm: boolean;
}

export function Password() {
  const _errors: Errors = {
    password: false,
    passwordConfirm: false,
  };

  const dispatch = useAppDispatch();
  const [password, setPassword] = React.useState<string | undefined>(undefined);
  const [passwordConfirm, setPasswordConfirm] = React.useState<string | undefined>(undefined);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showPassword1, setShowPassword1] = useState<boolean>(false);
  const [err, setErr] = React.useState<string | null>(null);
  const [errors, setErrors] = React.useState<Errors>(_errors);
  const params: any = useParams();
  const token = params.token

  const submit = async () => {
    if (!password) {
      setErrors({ ...errors, password: true });
      const msg = "Please Enter a New Password";
      setErr(msg);
      return;
    }
    if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password)) {
      setErrors({ ...errors, password: true });
      const msg = 'Minimum six characters, at least one uppercase letter, one lowercase letter and one number'
      setErr(msg);
      return;
    }
    if (!passwordConfirm) {
      setErrors({ ...errors, passwordConfirm: true });
      const msg = "repeat_password";
      setErr(msg);
      return;
    }

    if (password !== passwordConfirm) {
      setErrors({ ...errors, passwordConfirm: true });
      const msg = 'Passwords do not match. Please try again.'
      setErr(msg);
      return;
    }

    await dispatch(resetPassword({ password: Buffer.from(password).toString('base64'), token: token as string }));
  };

  return (

      <Grid container sx={{mt: '15em'}} justifyContent="center" alignItems={"center"}>
        <Grid item xs={5}>
          <Paper style={{ padding: 20 }}>
            <Grid
              container
              direction="row"
              justifyContent="space-evenly"
              alignItems="center"
              spacing={2}
              style={{ padding: 20 }}
            >
              <Grid  xs={12} item style={{}}>
                <Typography variant="h6" align="center">
                  Reset Password
                </Typography>
              </Grid>{" "}
              <Grid xs={8} item style={{ margin: "0 auto" }}>
                <hr style={{ height: "1px", background: "black", width: "100%" }}></hr>
              </Grid>
              <Grid  sm={9} item style={{}}>
              <Typography  align="center" fontStyle={"italic"}>
                 Note: The password has to contain a minimum of six characters, one uppercase letter, one lowercase letter and one number <br/><br/>
                </Typography>
                <InputLabel htmlFor="outlined-adornment-password">Enter New Password</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  required
                  fullWidth
                  onChange={(e: any) => {
                    setErr(null);
                    setPassword(e.target.value);
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(true)}
                        onMouseDown={() => setShowPassword(false)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid lg={9} sm={9} item style={{}}>
                <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword1 ? "text" : "password"}
                  value={passwordConfirm}
                  required
                  fullWidth
                  onChange={(e: any) => {
                    setErr(null);
                    setPasswordConfirm(e.target.value);
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword1(true)}
                        onMouseDown={() => setShowPassword1(false)}
                        edge="end"
                      >
                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid xl={9} xs={9} item style={{}}>
                <ActionButton action={submit} name={"Update"} local_error={err} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>


  );
}
